<h2 class="text-xl font-bold mb-4">Finale Entscheidung</h2>

<div class="mb-6">
  <p class="mb-4">
    Nach Abschluss aller Prüfungen sollte der Prüfer eine endgültige
    Entscheidung treffen:
  </p>

  <div class="space-y-6">
    <div>
      <h3 class="text-lg font-semibold text-green-600 flex items-center mb-2">
        <span class="mr-2">✅</span> Angebot akzeptieren
      </h3>
      <p class="ml-8">Wenn alle Kriterien erfüllt sind.</p>
    </div>

    <div>
      <h3 class="text-lg font-semibold text-red-600 flex items-center mb-2">
        <span class="mr-2">❌</span> Angebot ablehnen
      </h3>
      <p class="ml-8">Wenn schwerwiegende Verstöße oder Mängel bestehen.</p>
    </div>

    <div>
      <h3 class="text-lg font-semibold text-blue-600 flex items-center mb-2">
        <span class="mr-2">🔄</span> Überarbeitung anfordern
      </h3>
      <p class="ml-8">Wenn kleinere Mängel behoben werden müssen.</p>
    </div>
  </div>
</div>

<div class="mt-4 p-4 bg-blue-50 rounded-lg">
  <p class="flex items-center text-blue-800">
    <span class="mr-2">➡</span>
    <span class="font-semibold">Best Practice:</span>
    Falls Änderungen erforderlich sind, sollte dem Antragsteller eine klare,
    strukturierte Rückmeldung mit Verbesserungsvorschlägen gegeben werden.
  </p>
</div>
